import { useSelector } from 'react-redux';
import { getRegion } from 'utils/Region';

export const useMiniplayerRetryConfig = () =>
  useSelector(state => {
    if (state.metadata.miniplayer_retry_config) {
      const config = JSON.parse(state.metadata.miniplayer_retry_config);
      const region = getRegion();
      if (config[region]) return config[region].attempts;
      return config.default?.attempts ?? 1;
    }
    return 1;
  });

export default useMiniplayerRetryConfig;
